module.exports = __webpack_public_path__ + "assets/img/change.06748429.png";